import React from 'react';
import { Box } from '@mui/material';

const Banner = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '80px', // Adjust as needed to ensure visibility
        right: '-35px',  // Adjust as needed to ensure visibility
        width: '170px',  // Adjust width to ensure full visibility
        height: '40px',  // Adjust height to ensure full visibility
        backgroundColor: 'red',
        color: 'white',
        textAlign: 'center',
        lineHeight: '40px', // Adjust to vertically center the text
        transform: 'rotate(-45deg)', // Rotate by -45 degrees
        transformOrigin: 'bottom right',
        zIndex: 1000, // Ensure it appears above other elements
      }}
    >
      TEST
    </Box>
  );
};

export default Banner;
